/* eslint-disable no-redeclare */
// import { filter } from 'lodash';
import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker,  LocalizationProvider } from '@mui/x-date-pickers';
import Page from '../../components/Page';
import * as Moment from 'moment';
// import Close from '@mui/icons-material/Close';
import {CalendarTodayOutlined as CalendarMonthIcon} from '@mui/icons-material';
// material
import { Button,Grid,IconButton,  FormControl, DialogContentText,RadioGroup, FormLabel,FormControlLabel,Radio, DialogActions, Card, Stack, TextField, Typography,Dialog,DialogTitle,DialogContent } from '@mui/material';
import LoaderContent from '../../components/Loader';
 import HTTPManager from '../../utils/httpRequestManager';
 import './tabs.css';

//  const ITEM_HEIGHT = 48;
//  const ITEM_PADDING_TOP = 8;
//  const MenuProps = {
//      PaperProps: {
//        style: {
//          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//          width: 250,
//        },
//      },
//    };
export default class ReportComponent extends React.Component{
    httpManager = new HTTPManager();
    constructor(props) {
        super(props);
         this.state = {
            employee_reportlist:[],
            from_date:new Date(),
            to_date:new Date(),
            reportType:'Owner',
            reportPeriod:'daily',
            tabName:'Owner',
            empReport:[],
            isAuthenticated : false,
            userDetail:{},
            discounts:[],
            showFormError: false,
            formError:'',
            owner:{},
            payments:[],
            employees:[], profit:'',
            OwnerDiscount:0,
            printhtml:'',
            merchantDetail:{}
         }

         this.handlechangeFromDate = this.handlechangeFromDate.bind(this);
         this.handlechangeToDate = this.handlechangeToDate.bind(this);
         this.submiteReport = this.submiteReport.bind(this)
         this.formatOwnerReport = this.formatOwnerReport.bind(this)
         this.handleType = this.handleType.bind(this);
    }

    handleType(e){
        this.setState({reportPeriod:e.target.value});
    }

    getProfile(){
        this.httpManager.getRequest(`/merchant/profile/getProfile`).then(res=>{
            var merchantDetail = res.merchants && res.merchants.length > 0
                ? (res.merchants[0].dataValues || res.merchants[0])
                : {};
            this.setState({isAuthenticated: true, userDetail: res.data, merchantDetail: merchantDetail}, ()=>{
                this.getReports();
            });
        }).catch(e=>{
            this.setState({showFormError: true, formError: e.message || "Failed to load profile."});
        });
    }

    handlechangeFromDate(e){
        this.setState({from_date: e});
    }
    handlechangeToDate(e){
        this.setState({to_date: e});
    }
    submiteReport() {
        this.getReports();
    }


    componentDidMount(){
        this.getProfile();
    }

    getTotalDiscounts(data){

        var total = 0
        data.forEach(e=>{
            total = Number(total)+Number(e.discountAmount)
        })
        total += Number(this.state.OwnerDiscount)
        return total.toFixed(2)
    }


    getEmpTotalDiscounts(data){
        //console.log(data)
        var total = 0
        if(data instanceof Array){
            data.forEach(e=>{
                if(e.mDiscountDivisionType === 'Both' && e.discountType === undefined)
                    total = Number(total)+(Number(e.discountAmount) * Number(e.mEmployeeDivision)/100)
                else
                    total = Number(total)+Number(e.discountAmount)
            })
        }

        return total.toFixed(2)
    }

    getTotalAmountcollected(){
        var total = 0
        this.state.payments.forEach(e=>{
            total = Number(total)+Number(e.paymentAmount)
        })

        return total.toFixed(2)
    }
    getReportTitle(){
        switch(this.state.tabName){
            case 'Owner':           return 'Sale Report';
            case 'All Employee':    return 'All Technicians Report';
            case 'Owner Employee':  return 'Self Service Report';
            case 'Employee':        return 'Summary Service Report';
            case 'EmployeeDetailed':return 'Daily Detail Report';
            default:                return 'Report';
        }
    }

    getReports(){
        const payload = {
            type: this.state.tabName,
            reportPeriod: this.state.reportPeriod,
            from_date: Moment(this.state.from_date).format("YYYY-MM-DD"),
            to_date: Moment(this.state.to_date).format("YYYY-MM-DD")
        };
        if(this.state.tabName === 'Owner'){
            this.setState({isLoading: true});
            this.httpManager.postRequest('merchant/report/getReport', payload).then(res=>{
                this.setState({ payments: res.payments, owner: res.owner, discounts: res.discounts, OwnerDiscount: 0, isLoading: false }, ()=>{
                    this.formatOwnerReport(res.data, { addedDates:[], data:[] })
                })
            }).catch(e=>{
                this.setState({isLoading: false, showFormError: true, formError: e.message || "Failed to load report."})
            })
        }
        else{
            // All Employee, Owner Employee, Employee, EmployeeDetailed
            this.setState({isLoading: true, employees: []});
            this.httpManager.postRequest('merchant/report/getEmpReport', {
                ...payload,
                notOwner: this.state.tabName === 'All Employee'
            }).then(res=>{
                this.setState({OwnerDiscount: 0, isLoading: false}, ()=>{
                    this.formatEmployeeData(res.data, [])
                })
            }).catch(e=>{
                this.setState({isLoading: false, showFormError: true, formError: e.message || "Failed to load employee report."})
            })
        }
    }

    formatEmployeeData(data,response, i=0){
        //console.log("DATA CALLLING", data)
        if(i < data.length){
            var obj = {
                addedDates:[],
                data:[],
                discounts:data[i].discounts,
                empdetail: data[i].emp,
                nettAmount:0,
                nettTotal:0,
                refundedAmount: data[i].refundedAmount["refundedAmount"],
                voidedAmount: data[i].refundedAmount["voidedAmount"] || 0
            }
            if(this.state.tabName === 'EmployeeDetailed'){
                this.formatDailyDetailReport(data, data[i].report, response, obj, i, 0)
            } else {
                this.formatEmployeeReport(data, data[i].report, response, obj,i,  0)
            }
        }
        else{
            this.setState({employees: response, showDatePopup: false}, ()=>{
                //console.log(this.state.employees)
            })
        }

    }



    formatOwnerReport(data,response, i=0){
        ////console.log(data.length)
        if(i< data.length){
            var rec = data[i]
            //console.log(rec)
            if(response.addedDates.indexOf(rec.created) === -1){
                var obj = {
                    ticketCount:1,
                    servicesCount: rec.ServiceCount,
                    serviceTotal: rec.TotalServiceAmount,
                    serviceAmount: rec.ServiceAmount,
                    tips: rec.tipsAmount,
                    discount: Number(rec.Discount)+(rec.OwnerDiscount != null ? Number(rec.OwnerDiscount) : 0),
                    date: rec.created
                }
                //console.log("DIS", (rec.OwnerDiscount != null ? Number(rec.OwnerDiscount) : 0))
                //console.log(obj, this.state.OwnerDiscount, "------", rec.OwnerDiscount)
                var dis = Number(this.state.OwnerDiscount)+(rec.OwnerDiscount != null ? Number(rec.OwnerDiscount) : 0)
                this.setState({OwnerDiscount: dis}, ()=>{
                    ////console.log(this.state.OwnerDiscount)
                    response.data.push(obj);
                    response.addedDates.push(obj.date);
                    this.formatOwnerReport(data, response, i+1)
                    ////console.log(rec.OwnerDiscount, dis)
                })
            }
            else{
                var idx = response.addedDates.indexOf(rec.created)
                var obj1  = Object.assign({}, response.data[idx]);
                obj1 = {
                    ticketCount:obj1.ticketCount+1,
                    servicesCount: Number(obj1.servicesCount)+Number(rec.ServiceCount),
                    serviceTotal: Number(obj1.serviceTotal)+Number(rec.TotalServiceAmount),
                    serviceAmount:  Number(obj1.serviceAmount)+Number(rec.ServiceAmount),
                    tips: Number(obj1.tips)+Number(rec.tipsAmount),
                    discount: Number(obj1.discount)+Number(rec.Discount) +(rec.OwnerDiscount != null ? Number(rec.OwnerDiscount) : 0),
                    date: obj1.date
                }
                var dis1 = Number(this.state.OwnerDiscount)+(rec.OwnerDiscount != null ? Number(rec.OwnerDiscount) : 0)
                this.setState({OwnerDiscount: dis1},()=>{

                response.data[idx] = obj1;
                this.formatOwnerReport(data, response, i+1)
                })
            }
        }
        else{

            this.setState({employee_reportlist: response.data, showDatePopup: false}, ()=>{
                // ////console.log("EMP REPOTR", this.state.employee_reportlist)
            })
        }
    }

    getProfitAmount(){
        var profit = 0;
        this.state.employee_reportlist.forEach(e=>{
            profit = Number(profit)+Number(e.serviceAmount)
        })

        return profit.toFixed(2)
    }



    formatEmployeeReport(emps,data,response, empobj, ei ,i=0){
        if(i< data.length){
            var rec = data[i]
            if(empobj.addedDates.indexOf(rec.created) === -1){
                var obj = {
                    ticketCount:1,
                    servicesCount: rec.ServiceCount,
                    serviceTotal: rec.TotalServiceAmount,
                    serviceAmount: rec.ServiceAmount,
                    productAmount: Number(rec.ProductAmount) || 0,
                    tips: rec.Tips,
                    discount: Number(rec.Discount)+Number(rec.TicketDiscount),
                    date: rec.created
                }
                empobj.nettAmount = Number(empobj.nettAmount)+Number(rec.ServiceAmount)
                //console.log("ID",empobj.nettTotal, empobj.Tips)
                empobj.nettTotal = Number(empobj.nettTotal)+Number(rec.ServiceAmount)+(rec.Tips !== null ? Number(rec.Tips) : 0)-( Number(rec.Discount)+Number(rec.TicketDiscount))
                empobj.data.push(obj);
                empobj.addedDates.push(obj.date);
                this.formatEmployeeReport(emps, data, response, empobj,ei, i+1)
            }
            else{
                var idx = empobj.addedDates.indexOf(rec.created)
                //console.log(rec.created, idx)
                var obj1  = Object.assign({}, empobj.data[idx]);
                obj1 = {
                    ticketCount:obj1.ticketCount+1,
                    servicesCount: Number(obj1.servicesCount)+Number(rec.ServiceCount),
                    serviceTotal: Number(obj1.serviceTotal)+Number(rec.TotalServiceAmount),
                    serviceAmount: Number(obj1.serviceAmount)+Number(rec.ServiceAmount),
                    productAmount: Number(obj1.productAmount)+(Number(rec.ProductAmount)||0),
                    tips: Number(obj1.tips)+Number(rec.Tips),
                    discount: Number(obj1.discount)+Number(rec.Discount)+Number(rec.TicketDiscount),
                    date: obj1.date
                }
                empobj.nettAmount = Number(empobj.nettAmount)+Number(rec.ServiceAmount)
                empobj.nettTotal = Number(empobj.nettTotal)+Number(rec.ServiceAmount)+(rec.Tips !== null ? Number(rec.Tips) : 0)-( Number(rec.Discount)+Number(rec.TicketDiscount))

                //console.log("else",obj1.nettTotal, rec.Tips)
                empobj.data[idx] = obj1;
                this.formatEmployeeReport(emps, data, response, empobj, ei, i+1)
            }
        }
        else{
            response.push(empobj)
            this.formatEmployeeData(emps,  response, ei+1);
        }
    }

    // Daily Detail: one row per ticket (not grouped by date)
    formatDailyDetailReport(emps, data, response, empobj, ei, i=0){
        if(i < data.length){
            var rec = data[i];
            var obj = {
                ticketCount: 1,
                servicesCount: rec.ServiceCount,
                serviceTotal: rec.TotalServiceAmount,
                serviceAmount: rec.ServiceAmount,
                productAmount: Number(rec.ProductAmount) || 0,
                tips: rec.Tips,
                discount: Number(rec.Discount)+Number(rec.TicketDiscount),
                date: rec.created,
                time: rec.createdTime
            };
            empobj.nettAmount = Number(empobj.nettAmount)+Number(rec.ServiceAmount);
            empobj.nettTotal = Number(empobj.nettTotal)+Number(rec.ServiceAmount)+(rec.Tips !== null ? Number(rec.Tips) : 0)-(Number(rec.Discount)+Number(rec.TicketDiscount));
            empobj.data.push(obj);
            this.formatDailyDetailReport(emps, data, response, empobj, ei, i+1);
        } else {
            response.push(empobj);
            this.formatEmployeeData(emps, response, ei+1);
        }
    }

    getDiscountAmount(option){
        var disamt = '0.00';
        //console.log(this.state.discounts)
        this.state.discounts.forEach((d, i)=>{
            if(d.mDiscountDivisionType === option && d.discountAmount){
                disamt = d.discountAmount ? (Number(disamt)+Number(d.discountAmount)).toFixed(2)  : '0.00'
            }
        })
        return disamt;
    }

    renderOwnerReport(){
        var reportdetail = [];
        var merchantdetail = this.state.merchantDetail//mstr !== undefined && mstr !== '' ? JSON.parse(mstr) : {}

        reportdetail.push(<div style={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                <Typography variant="h4">{merchantdetail.merchantName}</Typography>
                <Typography variant="h5" style={{textTransform:'capitalize'}}>Owner : Sale Report</Typography>
                <Typography variant="subtitle2" style={{textTransform:'capitalize', fontWeight:'400'}}>{Moment(this.state.from_date).format("MM/DD/YYYY")+" - "+Moment(this.state.to_date).format("MM/DD/YYYY")}</Typography>
            </div>);

        reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row'}}>
                <Typography variant="body" style={{textTransform:'capitalize', fontWeight:'400'}}>Owner : <b>{this.state.userDetail.mEmployeeFirstName+" "+this.state.userDetail.mEmployeeLastName}</b></Typography>
        </div>)
        if(this.state.employee_reportlist.length > 0){
        // if(this.state.empReport.length > 0){
            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000'}}>
                <Grid container>
                    <Grid item xs={2}><b>{this.state.reporttype === 'annually' ? 'Year' : (this.state.reporttype === 'monthly') ? 'Month' : 'Date'}</b></Grid>
                    <Grid item xs={2}><b>Tickets</b></Grid>
                    <Grid item xs={2}><b>Service</b></Grid>
                    <Grid item xs={2}><b>Amount</b></Grid>
                    <Grid item xs={1}><b>Tip</b></Grid>
                    <Grid item xs={1}><b>Discount</b></Grid>
                    <Grid item xs={2}><b>Total</b></Grid>
                </Grid>
            </div>)


            var totalServicePrice = 0
            var totalTips = 0
            var discounttotal = 0
            var totalAmount = 0

            this.state.employee_reportlist.forEach(t=>{
                //console.log(t)
                totalServicePrice =Number(totalServicePrice)+Number(t.serviceTotal);
                totalTips =Number(totalTips)+Number(t.tips);
                //console.log(totalTips, Number(totalTips),"+",Number(t.tips))
                totalAmount =Number(totalAmount)+Number(t.serviceTotal)+Number(t.tips)-Number(t.discount);
                discounttotal =Number(discounttotal)+Number(t.discount);
                reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000', padding:'2px 0'}}>
                    <Grid container>
                        <Grid item xs={2}>{t.date}</Grid>
                        <Grid item xs={2} >{t.ticketCount} </Grid>
                        <Grid item xs={2} >{t.servicesCount} </Grid>
                        <Grid item xs={2}>{Number(t.serviceTotal) > 0 ? "$"+Number(t.serviceTotal).toFixed(2) : '-' }</Grid>
                        <Grid item xs={1}>{Number(t.tips) > 0 ? "$"+Number(t.tips).toFixed(2) : '-' }</Grid>
                        <Grid item xs={1}>{Number(t.discount) > 0 ? "$"+Number(t.discount).toFixed(2) : '-' }</Grid>
                        <Grid item xs={2}>{(Number(t.serviceTotal)+Number(t.tips)-Number(t.discount)) > 0 ? "$"+(Number(t.serviceTotal)+Number(t.tips)-Number(t.discount)).toFixed(2) : '-' }</Grid>
                    </Grid>
                </div>)

            })
            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row'}}>
                <Grid container>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={4}><b>Total</b></Grid>
                    <Grid item xs={2}><b>{"$"+Number(totalServicePrice).toFixed(2)}</b></Grid>
                    <Grid item xs={1}><b>{"$"+Number(totalTips).toFixed(2)}</b></Grid>
                    <Grid item xs={1}><b>{"$"+Number(discounttotal).toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>{"$"+Number(totalAmount).toFixed(2)}</b></Grid>
                </Grid>
            </div>)

            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'column', marginTop:'2rem'}}>

                    <Typography variant="h6" style={{textTransform:'capitalize', fontWeight:'700'}}>Discounts</Typography>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}># Service Discounts</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.ServiceDiscountsTotal != null) ? Number(this.state.owner.ServiceDiscountsTotal).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}># Ticket Discounts</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.TicketDiscountsTotal != null) ? Number(this.state.owner.TicketDiscountsTotal).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Owner</Grid>
                        <Grid item xs={4}>{this.getDiscountAmount('Owner')}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Employee</Grid>
                        <Grid item xs={4}>{this.getDiscountAmount('Employee')}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Owner &amp; Employee</Grid>
                        <Grid item xs={4}>{this.getDiscountAmount('Both')}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Total</Grid>
                        <Grid item xs={4}>${this.getTotalDiscounts(this.state.discounts)}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'2rem', width:'100%'}}>
                        <Grid item xs={8}>Tax Amount</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.TotalTax != null) ? Number(this.state.owner.TotalTax).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Additional Charges</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.TotalAddCharges != null) ? Number(this.state.owner.TotalAddCharges).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Gift Card Additional Charges</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.giftCardAddCharge != null) ? Number(this.state.owner.giftCardAddCharge).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Supplies</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.Supplies != null) ? Number(this.state.owner.Supplies).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Gift Cards</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.GiftCards != null) ? Number(this.state.owner.GiftCards).toFixed(2) : "0.00"}</Grid>
                    </Grid>

                    {this.state.payments.length > 0 && <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'2rem', width:'100%'}}>
                        <Grid item xs={8}>Payment Methods</Grid>
                        <Grid item xs={4}></Grid>
                    </Grid>}
                    {this.state.payments.map(csh=>{
                        if(Number(csh.paymentAmount) <= 0) return null;
                        return <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                            <Grid item xs={8}>{csh.paymentType !== '' ? csh.paymentType : (csh.payMode === 'Loyalty Points' ? csh.payMode : 'Cash')}</Grid>
                            <Grid item xs={4}>${Number(csh.paymentAmount).toFixed(2)}</Grid>
                        </Grid>;
                    })}

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', marginTop:10}}>
                        <Grid item xs={8}>Refunded Amount</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.RefundedAmount != null) ? Number(Math.abs(this.state.owner.RefundedAmount)).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', marginTop:10}}>
                        <Grid item xs={8}>Voided Amount</Grid>
                        <Grid item xs={4}>${(this.state.owner && this.state.owner.VoidedAmount != null) ? Number(Math.abs(this.state.owner.VoidedAmount)).toFixed(2) : "0.00"}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', marginTop:10}}>
                        <Grid item xs={8} style={{color:'green'}}>Amount Collected</Grid>
                        <Grid item xs={4} style={{color:'green'}}>${this.getTotalAmountcollected()}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', marginTop:10}}>
                        <Grid item xs={8}>Profit</Grid>
                        <Grid item xs={4}>${this.getProfitAmount()}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', marginTop:'2rem'}}>
                        <Grid item xs={8}>No.Of Product Sales</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.ProductCount != null) ? this.state.owner.ProductCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Services Done</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.ServiceCount != null) ? this.state.owner.ServiceCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Tickets</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.TicketCount != null) ? this.state.owner.TicketCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Partially Paid Tickets</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.PartiallyPaidCount != null) ? this.state.owner.PartiallyPaidCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Paid Tickets</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.TicketCount != null) ? this.state.owner.TicketCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Partially Refunded Tickets</Grid>
                        <Grid item xs={4}>0</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Refunded Tickets</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.RefundedTicketCount != null) ? this.state.owner.RefundedTicketCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Voided Tickets(After Payment)</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.VoidedTicketCount != null) ? this.state.owner.VoidedTicketCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Voided Tickets(Before Payment)</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.VoidedTicketCountBP != null) ? this.state.owner.VoidedTicketCountBP : 0}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', marginTop:10}}>
                        <Grid item xs={8}>Transaction Summary:</Grid>
                        <Grid item xs={4}></Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Transactions</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.transactionsCount != null) ? this.state.owner.transactionsCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Refunded Transactions</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.RefundedTransactionsCount != null) ? this.state.owner.RefundedTransactionsCount : 0}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>No.Of Voided Transactions</Grid>
                        <Grid item xs={4}>{(this.state.owner && this.state.owner.VoidedTransactionsCount != null) ? this.state.owner.VoidedTransactionsCount : 0}</Grid>
                    </Grid>

                </div>)
        }
        else{
            reportdetail.push(<div style={{display:'flex',marginTop:'1rem',width:'100%', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
                <Typography variant="body" style={{textTransform:'capitalize', fontWeight:'400'}}>No tickets found for this time period.</Typography>
            </div>)
        }

        reportdetail.push(<div style={{display:'flex',marginTop:'1.5rem',width:'100%', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
            <Typography variant="body" style={{ paddingBottom:'1rem',fontWeight:'400'}}>{merchantdetail.merchantName} - Reported: {Moment().format("MM/DD/YYYY hh:mm a")}</Typography>
        </div>)

        return  <div style={{borderBottom:'1px dotted #000', paddingBottom:'1rem', width:'100%'}}>
            {reportdetail}
            </div>;
    }
    getEmpDiscountAmount(emp,option){
        var disamt = '0.00';
        emp.discounts.forEach((d, i)=>{
            if(d.mDiscountDivisionType === option && d.discountAmount){
                if(option === 'Both' && d.discountType === undefined)
                    disamt = d.discountAmount ? (Number(disamt)+(Number(d.discountAmount)*Number(d.mEmployeeDivision)/100)).toFixed(2)  : '0.00'
                else
                    disamt = d.discountAmount ? (Number(disamt)+Number(d.discountAmount)).toFixed(2)  : '0.00'
                //console.log(disamt)
            }
        })
        return disamt;
    }


    renderDailyDetailReport(){
        var reportdetail = [];
        var empList = [...this.state.employees];

        empList.forEach(emp => {
            // Employee header
            reportdetail.push(<div style={{display:'flex',width:'100%', marginBottom:'0.5rem'}}>
                <Typography variant="body1"><b>Employee : {emp.empdetail.mEmployeeFirstName+" "+emp.empdetail.mEmployeeLastName}</b></Typography>
            </div>)

            var totalServicePrice = 0;
            var totalQty = 0;
            var totalTips = 0;
            var totalAmount = 0;

            if(emp.data.length > 0){
                // Table header — matches POS: Date | Time | Qty | Service Amt | Tip | Total
                reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000'}}>
                    <Grid container>
                        <Grid item xs={2}><b>Date</b></Grid>
                        <Grid item xs={2}><b>Time</b></Grid>
                        <Grid item xs={2}><b>Qty</b></Grid>
                        <Grid item xs={2}><b>Service Amt</b></Grid>
                        <Grid item xs={2}><b>Tip</b></Grid>
                        <Grid item xs={2}><b>Total</b></Grid>
                    </Grid>
                </div>)

                emp.data.forEach(t => {
                    totalServicePrice = Number(totalServicePrice)+Number(t.serviceTotal||0);
                    totalQty = Number(totalQty)+Number(t.servicesCount||0);
                    totalTips = Number(totalTips)+Number(t.tips||0);
                    totalAmount = Number(totalAmount)+Number(t.serviceTotal||0)+Number(t.tips||0);
                    reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000', padding:'2px 0'}}>
                        <Grid container>
                            <Grid item xs={2}>{t.date}</Grid>
                            <Grid item xs={2}>{t.time || '-'}</Grid>
                            <Grid item xs={2}>{t.servicesCount || '-'}</Grid>
                            <Grid item xs={2}>{Number(t.serviceTotal)>0 ? "$"+Number(t.serviceTotal).toFixed(2) : '-'}</Grid>
                            <Grid item xs={2}>{Number(t.tips)>0 ? "$"+Number(t.tips).toFixed(2) : '-'}</Grid>
                            <Grid item xs={2}>{(Number(t.serviceTotal||0)+Number(t.tips||0))>0 ? "$"+(Number(t.serviceTotal||0)+Number(t.tips||0)).toFixed(2) : '-'}</Grid>
                        </Grid>
                    </div>)
                })

                // Totals row
                reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000'}}>
                    <Grid container>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}><b>Total</b></Grid>
                        <Grid item xs={2}><b>{"$"+Number(totalQty).toFixed(2)}</b></Grid>
                        <Grid item xs={2}><b>{"$"+Number(totalServicePrice).toFixed(2)}</b></Grid>
                        <Grid item xs={2}><b>{Number(totalTips)>0 ? "$"+Number(totalTips).toFixed(2) : '-'}</b></Grid>
                        <Grid item xs={2}><b>{"$"+Number(totalAmount).toFixed(2)}</b></Grid>
                    </Grid>
                </div>)
            } else {
                reportdetail.push(<div style={{display:'flex',marginTop:'0.5rem',width:'100%', alignItems:'center', justifyContent:'center'}}>
                    <Typography variant="body2">No tickets made during this time period by {emp.empdetail.mEmployeeFirstName+" "+emp.empdetail.mEmployeeLastName}</Typography>
                </div>)
            }

            // Summary section — matches POS Daily Detail layout
            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'column', marginTop:'2rem', marginBottom:'3rem'}}>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                    <Grid item xs={8}><Typography variant="h6" style={{fontWeight:'700'}}>Total Daily Amount</Typography></Grid>
                    <Grid item xs={4}>{"$"+Number(totalAmount).toFixed(2)}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Supplies</Grid>
                    <Grid item xs={4}>${(emp.empdetail.Supplies != null) ? Number(emp.empdetail.Supplies).toFixed(2) : "0.00"}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'0.5rem', marginBottom:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Service Amount ({(emp.empdetail.mEmployeePercentage||0)+"% Of $"+Number(totalServicePrice).toFixed(2)})</Grid>
                    <Grid item xs={4}>${emp.nettAmount != null ? (Number(emp.nettAmount)+Math.abs(Number(emp.refundedAmount))).toFixed(2) : "0.00"}</Grid>
                </Grid>

                <Typography variant="h6" style={{textTransform:'capitalize', fontWeight:'700'}}>Discounts</Typography>
                <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7}>Employee</Grid>
                    <Grid item xs={4}>{this.getEmpDiscountAmount(emp,'Employee')}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7}>Owner &amp; Employee</Grid>
                    <Grid item xs={4}>{this.getEmpDiscountAmount(emp,'Both')}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                    <Grid item xs={8}>Total Discounted</Grid>
                    <Grid item xs={4}>${this.getEmpTotalDiscounts(emp.discounts)}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Tax Amount</Grid>
                    <Grid item xs={4}>${(emp.empdetail.TotalTax != null) ? Number(emp.empdetail.TotalTax).toFixed(2) : "0.00"}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Refunded</Grid>
                    <Grid item xs={4}>{emp.refundedAmount != null ? "($"+Number(Math.abs(Number(emp.refundedAmount))).toFixed(2)+")" : "($0.00)"}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'0.5rem', width:'100%'}}>
                    <Grid item xs={8}>Voided</Grid>
                    <Grid item xs={4}>{emp.voidedAmount ? "($"+Number(Math.abs(Number(emp.voidedAmount))).toFixed(2)+")" : "($0.00)"}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Tip Amount</Grid>
                    <Grid item xs={4}>{"$"+Number(totalTips).toFixed(2)}</Grid>
                </Grid>

                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Total Payouts</Grid>
                    <Grid item xs={4}>${emp.nettTotal != null ? (Math.round(Number(emp.nettTotal)*100)/100).toFixed(2) : "0.00"}</Grid>
                </Grid>

            </div>)
        })

        return(<div style={{display:'flex', width:'100%', flexDirection:'column', alignItems:'flex-start', justifyContent:'flex-start', padding:'1rem'}}>
            <div style={{width:'100%', textAlign:'center', marginBottom:'1rem'}}>
                <Typography variant="h5" style={{fontWeight:'700'}}>{this.state.merchant && this.state.merchant.mMerchantName}</Typography>
                <Typography variant="h6" style={{fontWeight:'700'}}>EMPLOYEE : Daily Detail Report</Typography>
                <Typography variant="body2">{Moment(this.state.from_date).format('MM/DD/YYYY')+" - "+Moment(this.state.to_date).format('MM/DD/YYYY')}</Typography>
            </div>
            {reportdetail}
        </div>)
    }

    renderEmployeeReport(){
        var reportdetail = [];
        var merchantdetail = this.state.merchantDetail;
        var reportTitle = this.getReportTitle();
        // For Self Service tab, show only the logged-in user's entry
        var empList = this.state.employees;
        if(this.state.tabName === 'Owner Employee'){
            var myId = this.state.userDetail && this.state.userDetail.mEmployeeId;
            empList = empList.filter(emp => emp.empdetail && emp.empdetail.mEmployeeId === myId);
        }
        // If filtered list is empty (Self Service: logged-in user not in active employees)
        if(empList.length === 0){
            return <div style={{display:'flex',marginTop:'1rem',width:'100%', alignItems:'center', justifyContent:'center'}}>
                <Typography variant="subtitle2">No records found for this time period.</Typography>
            </div>;
        }
    empList.forEach(emp=>{
        reportdetail.push(<div style={{ display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                <Typography variant="h4">{merchantdetail.merchantName}</Typography>
                <Typography variant="h5" style={{textTransform:'capitalize'}}>{reportTitle}</Typography>
                <Typography variant="subtitle2" style={{textTransform:'capitalize', fontWeight:'400'}}>{Moment(this.state.from_date).format("MM/DD/YYYY")+" - "+Moment(this.state.to_date).format("MM/DD/YYYY")}</Typography>
            </div>);

        reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row'}}>
                <Typography variant="body" style={{textTransform:'capitalize', fontWeight:'400'}}>Employee : <b>{emp.empdetail.mEmployeeFirstName+" "+emp.empdetail.mEmployeeLastName}</b></Typography>
        </div>)
        // POS: always render full report for Self Service tab (Owner employee), even with 0 tickets
        var totalServicePrice = 0;
        var totalProductPrice = 0;
        var totalTips = 0;
        var discounttotal = 0;
        var totalAmount = 0;

        if(emp.data.length > 0 || this.state.tabName === 'Owner Employee'){
            // Table header — matches POS: Date | Tickets | Service | Product Amt | Service Amt | Tip | Total
            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000'}}>
                <Grid container>
                    <Grid item xs={2}><b>{this.state.reportPeriod === 'annually' ? 'Year' : (this.state.reportPeriod === 'monthly') ? 'Month' : 'Date'}</b></Grid>
                    <Grid item xs={1}><b>Tickets</b></Grid>
                    <Grid item xs={1}><b>Service</b></Grid>
                    <Grid item xs={2}><b>Product Amt</b></Grid>
                    <Grid item xs={2}><b>Service Amt</b></Grid>
                    <Grid item xs={2}><b>Tip</b></Grid>
                    <Grid item xs={2}><b>Total</b></Grid>
                </Grid>
            </div>)

            emp.data.forEach(t=>{
                totalServicePrice = Number(totalServicePrice)+Number(t.serviceTotal||0);
                totalProductPrice = Number(totalProductPrice)+Number(t.productAmount||0);
                totalTips = Number(totalTips)+Number(t.tips);
                totalAmount = Number(totalAmount)+Number(t.serviceTotal||0)+Number(t.tips);
                discounttotal = Number(discounttotal)+Number(t.discount);
                reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000', padding:'2px 0'}}>
                    <Grid container>
                        <Grid item xs={2}>{t.date}</Grid>
                        <Grid item xs={1}>{t.ticketCount}</Grid>
                        <Grid item xs={1}>{t.servicesCount}</Grid>
                        <Grid item xs={2}>{Number(t.productAmount)>0 ? "$"+Number(t.productAmount).toFixed(2) : '-'}</Grid>
                        <Grid item xs={2}>{Number(t.serviceTotal)>0 ? "$"+(Number(t.serviceTotal)-Number(t.productAmount||0)).toFixed(2) : '-'}</Grid>
                        <Grid item xs={2}>{Number(t.tips)>0 ? "$"+Number(t.tips).toFixed(2) : '-'}</Grid>
                        <Grid item xs={2}>{(Number(t.serviceTotal||0)+Number(t.tips))>0 ? "$"+(Number(t.serviceTotal||0)+Number(t.tips)).toFixed(2) : '-'}</Grid>
                    </Grid>
                </div>)
            })

            // Totals row
            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row'}}>
                <Grid container>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={2}><b>Total</b></Grid>
                    <Grid item xs={2}><b>{"$"+Number(totalProductPrice).toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>{"$"+(Number(totalServicePrice)-Number(totalProductPrice)).toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>{"$"+Number(totalTips).toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>{"$"+Number(totalAmount).toFixed(2)}</b></Grid>
                </Grid>
            </div>)

            // Summary section — matches POS layout
            reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'column', marginTop:'2rem'}}>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}><Typography variant="h6" style={{fontWeight:'700'}}>Total Daily Amount</Typography></Grid>
                        <Grid item xs={4}>{"$"+Number(totalAmount).toFixed(2)}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                        <Grid item xs={8}>Supplies</Grid>
                        <Grid item xs={4}>${(emp.empdetail.Supplies != null) ? Number(emp.empdetail.Supplies).toFixed(2) : "0.00"}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'0.5rem', marginBottom:'1rem', width:'100%'}}>
                        <Grid item xs={8}>Service Amount ({(emp.empdetail.mEmployeePercentage||0)+"% of $"+(Number(totalServicePrice)-Number(emp.empdetail.Supplies||0)).toFixed(2)})</Grid>
                        <Grid item xs={4}>${emp.nettAmount != null ? (Number(emp.nettAmount)+Math.abs(Number(emp.refundedAmount))).toFixed(2) : "0.00"}</Grid>
                    </Grid>

                    <Typography variant="h6" style={{textTransform:'capitalize', fontWeight:'700'}}>Discounts</Typography>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={7}>Employee</Grid>
                        <Grid item xs={4}>${this.getEmpDiscountAmount(emp,'Employee')}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={7}>Owner &amp; Employee</Grid>
                        <Grid item xs={4}>${this.getEmpDiscountAmount(emp,'Both')}</Grid>
                    </Grid>
                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                        <Grid item xs={8}>Total Discounted</Grid>
                        <Grid item xs={4}>${this.getEmpTotalDiscounts(emp.discounts)}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                        <Grid item xs={8}>Tax Amount</Grid>
                        <Grid item xs={4}>${(emp.empdetail.TotalTax != null) ? Number(emp.empdetail.TotalTax).toFixed(2) : "0.00"}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                        <Grid item xs={8}>Voided</Grid>
                        <Grid item xs={4}>{emp.voidedAmount ? "($"+Number(Math.abs(Number(emp.voidedAmount))).toFixed(2)+")" : "($0.00)"}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'0.5rem', width:'100%'}}>
                        <Grid item xs={8}>Refunded</Grid>
                        <Grid item xs={4}>{emp.refundedAmount != null ? "($"+Number(Math.abs(Number(emp.refundedAmount))).toFixed(2)+")" : "($0.00)"}</Grid>
                    </Grid>

                    {this.state.tabName === 'Owner Employee' && <>
                        <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                            <Grid item xs={8}>From Emp</Grid>
                            <Grid item xs={4}>${(Math.round((Number(this.getProfitAmount()) - Number(emp.nettAmount || 0))*100)/100).toFixed(2)}</Grid>
                        </Grid>
                        <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'0.5rem', width:'100%'}}>
                            <Grid item xs={8}>From Owner</Grid>
                            <Grid item xs={4}>${emp.nettAmount != null ? (Math.round(Number(emp.nettAmount)*100)/100).toFixed(2) : "0.00"}</Grid>
                        </Grid>
                    </>}

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                        <Grid item xs={8}>Tip Amount</Grid>
                        <Grid item xs={4}>{"$"+Number(totalTips).toFixed(2)}</Grid>
                    </Grid>

                    <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                        <Grid item xs={8}>Daily Net Total</Grid>
                        <Grid item xs={4}>${this.state.tabName === 'Owner Employee' ? (Math.round(Number(this.getProfitAmount())*100)/100).toFixed(2) : (emp.nettTotal != null ? (Math.round(Number(emp.nettTotal)*100)/100).toFixed(2) : "0.00")}</Grid>
                    </Grid>

                </div>)
        }
        else{
            reportdetail.push(<div style={{display:'flex',marginTop:'1rem',width:'100%', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
                <Typography variant="body" style={{textTransform:'capitalize', fontWeight:'400'}}>No tickets made during this time period by {emp.empdetail.mEmployeeFirstName+" "+emp.empdetail.mEmployeeLastName}</Typography>
            </div>)
        }

        reportdetail.push(<div style={{borderBottom:'1px dotted #000',display:'flex',marginTop:'1.5rem',width:'100%', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
            <Typography variant="body" style={{fontSize:'12px', paddingBottom:'1rem',fontWeight:'400'}}>{merchantdetail.merchantName} - Reported: {Moment().format("MM/DD/YYYY hh:mm a")}</Typography>
        </div>)
    });

        return  <div style={{ paddingBottom:'1rem', width:'100%'}}>
            {reportdetail}
            </div>;
    }

    renderAllEmployeeReport(){
        var reportdetail = [];
        var merchantdetail = this.state.merchantDetail;

        // ===== HEADER =====
        reportdetail.push(
            <div style={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                <Typography variant="h4">{merchantdetail.merchantName}</Typography>
                <Typography variant="h5" style={{textTransform:'capitalize'}}>OWNER : All Technicians Report</Typography>
                <Typography variant="subtitle2" style={{textTransform:'capitalize', fontWeight:'400'}}>
                    {Moment(this.state.from_date).format("MM/DD/YYYY")+" - "+Moment(this.state.to_date).format("MM/DD/YYYY")}
                </Typography>
            </div>
        );

        // ===== TABLE HEADER =====
        reportdetail.push(
            <div style={{display:'flex', width:'100%', borderBottom:'1px solid #000', marginTop:'25px', paddingBottom:'5px'}}>
                <Grid container>
                    <Grid item xs={2}><b>Employee</b></Grid>
                    <Grid item xs={2}><b>Service Amt</b></Grid>
                    <Grid item xs={1}><b>Tips</b></Grid>
                    <Grid item xs={2}><b>Discount</b></Grid>
                    <Grid item xs={2}><b>Commission</b></Grid>
                    <Grid item xs={1}><b>Supplies</b></Grid>
                    <Grid item xs={2}><b>Total</b></Grid>
                </Grid>
            </div>
        );

        // ===== AGGREGATE TOTALS =====
        let empTotalService = 0;
        let empTotalTips = 0;
        let empTotalDiscount = 0;
        let empTotalCommission = 0;
        let empTotalNet = 0;
        let taxTotal = 0;
        let suppliesTotal = 0;
        let netTotal = 0;
        let totalRefund = 0;
        let totalVoidedAmount = 0;
        let nettTotal = 0;
        let getEmpDiscountAmt = 0;
        let getEmpOwnDiscountAmt = 0;
        let getEmpTotalDisc = 0;

        // ===== PER-EMPLOYEE ROWS =====
        this.state.employees.forEach(emp => {
            if (!emp.data || emp.data.length === 0) return;

            let empService = 0;    // raw service total (TotalServiceAmount)
            let empCommission = 0; // commission earned (ServiceAmount = ticketcommission)
            let empTips = 0;
            let empDiscount = 0;
            let empListDiscount = 0;

            emp.data.forEach(t => {
                empService += Number(t.serviceTotal || 0);
                empCommission += Number(t.serviceAmount || 0);
                empTips += Number(t.tips || 0);
                empDiscount += Number(t.discount || 0);
            });

            if (emp.discounts && emp.discounts.length > 0) {
                emp.discounts.forEach(d => {
                    empListDiscount += Number(d.discountAmount || 0);
                });
            }
            empDiscount += empListDiscount;

            const empSupplies = Number(emp.empdetail && emp.empdetail.Supplies != null ? emp.empdetail.Supplies : 0);
            const empTotal = empCommission + empTips - empDiscount;

            // Skip employees with no activity
            if (empService === 0 && empTips === 0 && empDiscount === 0 && empCommission === 0 && empSupplies === 0) return;

            // Accumulate grand totals
            empTotalService += empService;
            empTotalTips += empTips;
            empTotalDiscount += empDiscount;
            empTotalCommission += empCommission;
            suppliesTotal += empSupplies;
            empTotalNet += empTotal;

            taxTotal += Number(emp.empdetail && emp.empdetail.TotalTax != null ? emp.empdetail.TotalTax : 0);
            netTotal += Math.round((Number(emp.nettAmount || 0) + Math.abs(Number(emp.refundedAmount || 0))) * 1000) / 1000;
            totalRefund += Math.round(Number(emp.refundedAmount || 0) * 1000) / 1000;
            totalVoidedAmount += Math.round(Number(emp.voidedAmount || 0) * 1000) / 1000;
            nettTotal += Math.round(Number(emp.nettTotal || 0) * 1000) / 1000;

            getEmpDiscountAmt += Number(this.getEmpDiscountAmount(emp, 'Employee'));
            getEmpOwnDiscountAmt += Number(this.getEmpDiscountAmount(emp, 'Both'));
            getEmpTotalDisc += Number(this.getEmpTotalDiscounts(emp.discounts));

            const empName = (emp.empdetail ? emp.empdetail.mEmployeeFirstName : '') + ' ' + (emp.empdetail ? emp.empdetail.mEmployeeLastName : '');

            reportdetail.push(
                <div style={{display:'flex', width:'100%', borderBottom:'1px dotted #ccc', padding:'6px 0'}}>
                    <Grid container>
                        <Grid item xs={2}>{empName.trim()}</Grid>
                        <Grid item xs={2}>${empService.toFixed(2)}</Grid>
                        <Grid item xs={1}>${empTips.toFixed(2)}</Grid>
                        <Grid item xs={2}>${empDiscount.toFixed(2)}</Grid>
                        <Grid item xs={2}>${empCommission.toFixed(2)}</Grid>
                        <Grid item xs={1}>${empSupplies.toFixed(2)}</Grid>
                        <Grid item xs={2}>${empTotal.toFixed(2)}</Grid>
                    </Grid>
                </div>
            );
        });

        // ===== TOTAL ROW =====
        reportdetail.push(
            <div style={{display:'flex', width:'100%', borderTop:'2px solid #000', padding:'10px 0', marginTop:'5px'}}>
                <Grid container>
                    <Grid item xs={2}><b>Total</b></Grid>
                    <Grid item xs={2}><b>${empTotalService.toFixed(2)}</b></Grid>
                    <Grid item xs={1}><b>${empTotalTips.toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>${empTotalDiscount.toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>${empTotalCommission.toFixed(2)}</b></Grid>
                    <Grid item xs={1}><b>${suppliesTotal.toFixed(2)}</b></Grid>
                    <Grid item xs={2}><b>${empTotalNet.toFixed(2)}</b></Grid>
                </Grid>
            </div>
        );

        // ===== SUMMARY SECTION =====
        reportdetail.push(
            <div style={{display:'flex', width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'column', marginTop:'2rem'}}>
                <Typography variant="h6" style={{textTransform:'capitalize', fontWeight:'700'}}>Discounts</Typography>
                <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', paddingTop:'8px'}}>
                    <Grid item xs={8}>Employee</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>{getEmpDiscountAmt.toFixed(2)}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', paddingTop:'8px'}}>
                    <Grid item xs={8}>Owner &amp; Employee</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>{getEmpOwnDiscountAmt.toFixed(2)}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', paddingTop:'8px', borderTop:'1px dotted #ccc', paddingBottom:'8px'}}>
                    <Grid item xs={8}>Total</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>${getEmpTotalDisc.toFixed(2)}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Tax Amount</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>${taxTotal.toFixed(2)}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Supplies</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>${suppliesTotal.toFixed(2)}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Net</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>${(Math.round(Number(netTotal) * 100) / 100).toFixed(2)}</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Refunded</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>(${ (Math.round(Number(Math.abs(totalRefund)) * 100) / 100).toFixed(2)})</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%'}}>
                    <Grid item xs={8}>Voided</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>(${ (Math.round(Number(Math.abs(totalVoidedAmount)) * 100) / 100).toFixed(2)})</Grid>
                </Grid>
                <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'1rem', width:'100%', borderTop:'1px solid #000', paddingTop:'8px'}}>
                    <Grid item xs={8}>Net Total</Grid>
                    <Grid item xs={4} style={{textAlign:'right'}}>${nettTotal.toFixed(2)}</Grid>
                </Grid>
            </div>
        );

        // ===== FOOTER =====
        reportdetail.push(
            <div style={{borderBottom:'1px dotted #000', display:'flex', marginTop:'1.5rem', width:'100%', alignItems:'center', justifyContent:'center'}}>
                <Typography variant="body" style={{fontSize:'12px'}}>{merchantdetail.merchantName} - Reported: {Moment().format("MM/DD/YYYY hh:mm a")}</Typography>
            </div>
        );

        return <div style={{width:'100%', paddingBottom:'1rem'}}>{reportdetail}</div>;
    }

    // renderEmployeeReport(){
    //     var reportdetail = [];
    //     this.state.empReport.forEach(emp=>{
    //         reportdetail.push(<div style={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
    //             <Typography variant="h4">{this.state.businessdetail.name}</Typography>
    //             <Typography variant="h5" style={{textTransform:'capitalize'}}>Employee {this.state.reporttype} Report</Typography>
    //             <Typography variant="subtitle2" style={{textTransform:'capitalize', fontWeight:'400'}}>{Moment(this.state.from_date).format("MM/DD/YYYY")+" - "+Moment(this.state.to_date).format("MM/DD/YYYY")}</Typography>
    //         </div>);

    //         reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row'}}>
    //                 <Typography variant="body" style={{textTransform:'capitalize', fontWeight:'400'}}>Employee : <b>{emp.firstName+" "+emp.lastName}</b></Typography>
    //         </div>)
    //         if(emp.tickets.length > 0){
    //             reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000'}}>
    //                 <Grid container>
    //                     <Grid item xs={3}><b>{this.state.reporttype === 'annually' ? 'Year' : (this.state.reporttype === 'monthly') ? 'Month' : 'Date'}</b></Grid>
    //                     <Grid item xs={3}><b>Tickets</b></Grid>
    //                     <Grid item xs={2}><b>Amount</b></Grid>
    //                     <Grid item xs={2}><b>Tip</b></Grid>
    //                     <Grid item xs={2}><b>Total</b></Grid>
    //                 </Grid>
    //             </div>)
    //             var discounttotal = 0
    //             var totalAmount = 0;
    //             var totalTips = 0;
    //             emp.tickets.map(t=>{
    //                 return  reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000', padding:'2px 0'}}>
    //                     <Grid container>
    //                         <Grid item xs={3}>{t.ticket_date}</Grid>

    //                         <Grid item xs={3} style={{alignItems:'center', display:'flex', textDecoration:'underline', cursor:'pointer'}} onClick={()=>{
    //                             this.showDetails(t)
    //                         }}>{t.ticketcount}</Grid>
    //                         <Grid item xs={2}>{Number(t.Amount) > 0 ? "$"+Number(t.Amount).toFixed(2) : '-' }</Grid>
    //                         <Grid item xs={2}>{Number(t.Tips) > 0 ? "$"+Number(t.Tips).toFixed(2) : '-' }</Grid>
    //                         <Grid item xs={2}>{Number(t.Amount)+Number(t.Tips) > 0 ? "$"+(Number(t.Tips)+Number(t.Amount)).toFixed(2) : '-' }</Grid>
    //                     </Grid>
    //                 </div>)
    //             })

    //             emp.tickets.forEach(t=>{
    //                 discounttotal = discounttotal+ Number(t.Discount);
    //                 totalAmount = totalAmount+ Number(t.Amount);
    //                 totalTips = totalTips+ Number(t.Tips);
    //                 discounttotal = discounttotal+ Number(t.Discount);
    //             })

    //             discounttotal = emp.discountdata.OwnerDiscount+emp.discountdata.EmpDiscount+emp.discountdata.OwnerEmpDiscount;
    //             //console.log(discounttotal);

    //             reportdetail.push(
    //                 <div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'row', borderBottom:'1px solid #000',fontWeight:'700', padding:'2px 0'}}>
    //                     <Grid container><Grid item xs={3}></Grid>
    //                         <Grid item xs={3}>Total</Grid>
    //                         <Grid item xs={2}>{Number(totalAmount) > 0 ? "$"+Number(totalAmount).toFixed(2) : '-' }</Grid>
    //                         <Grid item xs={2}>{Number(totalTips) > 0 ? "$"+Number(totalTips).toFixed(2) : '-' }</Grid>
    //                         <Grid item xs={2}>{Number(totalTips)+Number(totalAmount) > 0 ? "$"+(Number(totalTips)+Number(totalAmount)).toFixed(2) : '-' }</Grid>
    //                     </Grid>
    //                 </div>)
    //             reportdetail.push(<div style={{display:'flex',width:'100%', alignItems:'flex-start', justifyContent:'flex-start', flexDirection:'column', marginTop:'2rem'}}>

    //                     <Typography variant="h6" style={{textTransform:'capitalize', fontWeight:'700'}}>Discounts</Typography>

    //                     <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
    //                         <Grid item xs={8}>#</Grid>
    //                         <Grid item xs={4}>{Number(discounttotal).toFixed(2)}</Grid>
    //                     </Grid>
    //                     <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
    //                         <Grid item xs={8}>Owner</Grid>
    //                         <Grid item xs={4}>{Number(emp.discountdata.OwnerDiscount).toFixed(2)}</Grid>
    //                     </Grid>

    //                     <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
    //                         <Grid item xs={8}>Employee</Grid>
    //                         <Grid item xs={4}>{Number(emp.discountdata.EmpDiscount).toFixed(2)}</Grid>
    //                     </Grid>

    //                     <Grid container style={{textTransform:'capitalize', fontWeight:'400', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
    //                         <Grid item xs={8}>Owner & Employee</Grid>
    //                         <Grid item xs={4}>{Number(emp.discountdata.OwnerEmpDiscount).toFixed(2)}</Grid>
    //                     </Grid>
    //                     <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%',}}>
    //                         <Grid item xs={8}>Total</Grid>
    //                         <Grid item xs={4}>${Number(discounttotal).toFixed(2)}</Grid>
    //                     </Grid>

    //                     <Grid container style={{textTransform:'capitalize', fontWeight:'700', display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'2rem', width:'100%',}}>
    //                         <Grid item xs={8}>Supplies</Grid>
    //                         <Grid item xs={4}>$0.00</Grid>
    //                     </Grid>
    //                 </div>)
    //         }
    //         else{
    //             reportdetail.push(<div style={{display:'flex',marginTop:'1rem',width:'100%', alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
    //                 <Typography variant="body" style={{textTransform:'capitalize', fontWeight:'400'}}>No tickets made during this time period by {emp.firstName+" "+emp.lastName}</Typography>
    //             </div>)
    //         }

    //         reportdetail.push(<div style={{display:'flex',marginTop:'1.5rem',width:'100%', alignItems:'center', justifyContent:'center', flexDirection:'row',borderBottom:'1px dotted #000', marginBottom:'1rem'}}>
    //             <Typography variant="body" style={{ paddingBottom:'1rem',fontWeight:'400'}}>{this.state.businessdetail.name} - Reported: {Moment().format("MM/DD/YYYY hh:mm a")}</Typography>
    //         </div>)
    //     })
    //     return  <div style={{ width:'100%'}}>
    //         {reportdetail}
    //         </div>;

    // }


    render(){
        return(
            <Page title="Report | Astro POS">
                 {this.state.isLoading && <LoaderContent show={this.state.isLoading} />}
                {this.state.isAuthenticated &&  <Card >
                                            <div className="tab" style={{backgroundColor:'#192740'}}>
                                <button className={this.state.tabName === 'Owner' ? "active tablinks": "tablinks"}
                                style={{color: this.state.tabName !== 'Owner' ? 'white' : ''}}
                                onClick={()=>{
                                    this.setState({tabName:'Owner'}, function(){ this.getReports() })
                                }}>Sale Report</button>

                                <button className={this.state.tabName === 'All Employee' ? "active tablinks": "tablinks"}
                                style={{color: this.state.tabName !== 'All Employee' ? 'white' : ''}}
                                onClick={()=>{
                                    this.setState({tabName:'All Employee'}, function(){ this.getReports() })
                                }}>All Technicians Report</button>

                                <button className={this.state.tabName === 'Owner Employee' ? "active tablinks": "tablinks"}
                                style={{color: this.state.tabName !== 'Owner Employee' ? 'white' : ''}}
                                onClick={()=>{
                                    this.setState({tabName:'Owner Employee'}, function(){ this.getReports() })
                                }}>Self Service Report</button>

                                <button className={this.state.tabName === 'Employee' ? "active tablinks": "tablinks"}
                                style={{color: this.state.tabName !== 'Employee' ? 'white' : ''}}
                                onClick={()=>{
                                    this.setState({tabName:'Employee'}, function(){ this.getReports() })
                                }}>Summary Service Report</button>

                                <button className={this.state.tabName === 'EmployeeDetailed' ? "active tablinks": "tablinks"}
                                style={{color: this.state.tabName !== 'EmployeeDetailed' ? 'white' : ''}}
                                onClick={()=>{
                                    const today = new Date();
                                    this.setState({tabName:'EmployeeDetailed', from_date: today, to_date: today}, function(){ this.getReports() })
                                }}>Daily Detail Report</button>
                            </div>
                            {this.state.tabName === 'Owner' &&
                            <div className="tabcontent">
                                    <Grid container style={{marginTop:'1rem', maxHeight:'80px'}}>
                                            <Grid item xs={12} md={8}></Grid>
                                            <Grid item xs={12} md={4}>
                                                <div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
                                                    <IconButton onClick={()=>{ this.setState({showDatePopup: true}) }}><CalendarMonthIcon/></IconButton>
                                                </div>
                                            </Grid>
                                    </Grid>
                                    <Grid container style={{marginTop:'1rem'}}>
                                            <Grid item xs={12} md={12}>
                                                <div style={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', padding:'2rem 5rem'}}>
                                                    {this.renderOwnerReport()}
                                                </div>
                                            </Grid>
                                    </Grid>
                            </div>}

                            {['All Employee','Owner Employee','Employee','EmployeeDetailed'].includes(this.state.tabName) && <div className="tabcontent">
                                <Grid container style={{marginTop:'1rem', display:'flex', maxHeight:'80px'}}>
                                                <Grid item xs={12} md={8}></Grid>
                                                <Grid item xs={12} md={4}>
                                                    <div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
                                                        <IconButton onClick={()=>{ this.setState({showDatePopup: true}) }}><CalendarMonthIcon/></IconButton>
                                                    </div>
                                                </Grid>
                                        </Grid>
                                    <Grid container style={{marginTop:'1rem'}}>
                                            <Grid item xs={12} md={12}>
                                                <div style={{display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem 5rem'}}>
                                                    {this.state.employees.length > 0 && (this.state.tabName === 'All Employee' ? this.renderAllEmployeeReport() : this.state.tabName === 'EmployeeDetailed' ? this.renderDailyDetailReport() : this.renderEmployeeReport())}
                                                    {this.state.employees.length === 0 && !this.state.isLoading && <div><Typography variant="subtitle2">No records found.</Typography></div>}
                                                </div>
                                            </Grid>
                                    </Grid>
                                </div>}
                            <Dialog
                                className="custommodal"
                                    open={this.state.showDatePopup}
                                    onClose={()=>{
                                        this.setState({showDatePopup: false, from_date: new Date(), to_date:new Date(), reporttype:'daily'})
                                    }}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    style={{borderRadius:'10px'}}
                                >
                                    <DialogTitle title="Select Date" id="alert-dialog-title">
                                    {/* <ModalHeader  onClose={()=>{
                                        this.setState({showDatePopup: false})
                                    }} /> */}
                                    </DialogTitle>
                                    <DialogContent>
                                    <DialogContentText id="alert-dialog-description">

                                            <Grid container>

                                                <Grid item xs={8} style={{padding:'20px'}}>
                                                    <form autoComplete="off" noValidate>
                                                        <Stack direction={'column'}>
                                                            <div  style={{margin:'10px 0'}}>
                                                            <LocalizationProvider dateAdapter={AdapterDateFns} fullWidth >
                                                                <DesktopDatePicker
                                                                    label="From"
                                                                    inputFormat="MM/dd/yyyy"
                                                                    maxDate={new Date()}
                                                                    style={{marginRight:'10px'}}
                                                                    value={this.state.from_date}
                                                                    onChange={this.handlechangeFromDate}
                                                                    renderInput={(params) => <TextField {...params} />}
                                                                />
                                                            </LocalizationProvider>
                                                            </div>
                                                            <div  style={{margin:'10px 0'}}>
                                                                <LocalizationProvider dateAdapter={AdapterDateFns} fullWidth
                                                                        style={{marginLeft:'10px'}}>
                                                                    <DesktopDatePicker
                                                                        label="To"
                                                                        inputFormat="MM/dd/yyyy"
                                                                        minDate={this.state.from_date}
                                                                        maxDate={new Date()}
                                                                        value={this.state.to_date}
                                                                        onChange={this.handlechangeToDate}
                                                                        style={{marginLeft:'10px'}}
                                                                        renderInput={(params) => <TextField {...params} />}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        </Stack>
                                                    </form>
                                                </Grid>
                                                <Grid item xs={4} style={{padding:'20px'}}>
                                                    <Stack direction={{ xs: 'column', sm: 'column' }} spacing={2}>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="legend">Report Type</FormLabel>
                                                            <RadioGroup  column aria-label="tax" name="row-radio-buttons-group">
                                                                <FormControlLabel   style={{margin:'10px 0'}} value={this.state.reportPeriod} control={<Radio checked={this.state.reportPeriod === 'daily'} value="daily" onChange={(e)=>{
                                                                    this.handleType(e)
                                                                }}/>} label="Daily" />
                                                                <FormControlLabel   style={{margin:'10px 0'}} value={this.state.reportPeriod} control={<Radio checked={this.state.reportPeriod === 'monthly'} value="monthly" onChange={(e)=>{
                                                                this.handleType(e) }}/>} label="Monthly" />
                                                                <FormControlLabel   style={{margin:'10px 0'}} value={this.state.reportPeriod} control={<Radio checked={this.state.reportPeriod === 'annually'} value="annually" onChange={(e)=>{
                                                                this.handleType(e) }}/>} label="Annually" />

                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                    </DialogContentText>
                                        </DialogContent>
                                    <DialogActions style={{display:'flex', alignItems:'center', justifyContent:'center', marginBottom:'1rem'}}>
                                        <Button variant="contained" onClick={()=>{this.setState({reportby:'changed'});this.getReports()}}> Get Report </Button>
                                    </DialogActions>
                        </Dialog>
                        </Card>
                }


                <Dialog
                    open={this.state.showFormError}
                    onClose={()=>{
                        this.setState({showFormError:false, formError: ''})
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Error
                    </DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.state.formError}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={()=>{
                             this.setState({showFormError:false, formError: ''})
                        }}>OK </Button>
                    </DialogActions>
                </Dialog>
            </Page>
        )
    }
}
